import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Turn } from '../interfaces/turn';

@Injectable({
  providedIn: 'root'
})
export class TurnService {
  private myAppUrl: string;
  private myApiUrl: string;

  constructor(private http: HttpClient) {
    this.myAppUrl = environment.endpoint;
    this.myApiUrl = 'api/turns/'
  }
  getListTurns(): Observable<Turn[]> {

      return this.http.get<Turn[]>(`${this.myAppUrl}${this.myApiUrl}`);
     }
   
     deleteTurn(id: number): Observable<void> {
       return this.http.delete<void>(`${this.myAppUrl}${this.myApiUrl}${id}`)
     }
   
     saveTurn(turn: Turn): Observable<void> {
       return this.http.post<void>(`${this.myAppUrl}${this.myApiUrl}`,turn)
     }
   
     getTurn(id: number): Observable<Turn> {
       return this.http.get<Turn>(`${this.myAppUrl}${this.myApiUrl}${id}`)
     }
   
     updateTurn(id: number, turn: Turn): Observable<void> {
       return this.http.put<void>(`${this.myAppUrl}${this.myApiUrl}${id}`, turn);
     }
   }